import script from "./TextAreaComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./TextAreaComponent.vue?vue&type=script&setup=true&lang=js"

import "./TextAreaComponent.vue?vue&type=style&index=0&id=8440dcfe&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8440dcfe"]])

export default __exports__